
function charCounter(str, setCharCount) {
    let c = 0;
    for (let i = 0; i < str.length; i++) {
            c++;
    }
    setCharCount(c);
}

export default charCounter;